import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IParamPosInsatallmentHistory } from '../models/models'

export class ListParamPosInsatallmentHistoryApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/posTransactionParam/listParamPosInsatallmentHistory',
      requesterInfo,
    })
  }

  public async listParamPosInsatallmentHistory(guid: string): Promise<IParamPosInsatallmentHistory[]> {
    this.props.url = `${this.props.url}/?guid=${guid}`
    return await this.getAsync<IParamPosInsatallmentHistory[]>()
  }
}
